import * as React from "react";
import Component from "../../AbstractComponent";
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Button from '@material-ui/core/Button';
import Constants from "../../../Action/Constants";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { CompanyInterface } from "../../../Entity/Entities/Company/CompanyInterface";
import { PromptDialog } from "./PromptDialog";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import ChargeClassContainer from "../../../Entity/Entities/Charge/ChargeClass/ChargeClassContainer";
import { ChargeInterface } from "../../../Entity/Entities/Charge/ChargeInterface";
import Formatter from "../../../Localization/Formatter";
import { DatePickerComponent } from "../../Partials/DatePicker/DatePickerComponent";
import Time from "../../../Time/Time";
import Checkbox from '@material-ui/core/Checkbox';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import * as uuidV4 from "uuid/v4";
// import { LeavePromptDialog } from "../../Partials/Dialog/LeavePromptDialog";
// import { Entity } from "Casadesk/Entity/Entity";
import CasedeskUrl from "../../../Url/Url";

export class CoachCollectiveInvoiceDialog extends Component {
  public state = {
    activeStep: 0,
    skipped: new Set(),
    openCreateCollectiveInvoiceCoachOpen: false,
    hasModifiedData: false,
    openLeavePrompt: false,
    disableButtonDuringRequest: false,
    errorFields: null,
    amazonFolderName: uuidV4(),
    address: null,
    selectedCompany: null,
    property: null,
    isFinishDialogOpen: false,
    charges: [],
    isItemSelected: null,
    selectedChargesRows: [],
    selectedCharges: [],
    dueDate: Time.addDays(new Date(), 3) || null,
    isSaving: false,
    contract: null,
    typeOfCollectiveInvoice: null
    };

  constructor(public props) {
    super(props);

  }

  public componentWillMount() {
    this.setState({
      contract: this.props.contract,
      openCreateCollectiveInvoiceCoachOpen: this.props.openCreateCollectiveInvoiceCoachOpen,
      typeOfCollectiveInvoice: this.props.typeOfCollectiveInvoice
    });
	}

	public componentWillReceiveProps(nextProps) {
    this.setState({
      contract: nextProps.contract,
      openCreateCollectiveInvoiceCoachOpen: nextProps.openCreateCollectiveInvoiceCoachOpen,
      charges: nextProps.unpaidContractCharges,
      typeOfCollectiveInvoice: nextProps.typeOfCollectiveInvoice
    });
  }

  public clearState = () => {
    this.setState({
      activeStep: 0,
      skipped: new Set(),
      openCreateCollectiveInvoiceCoachOpen: false,
      hasModifiedData: false,
      openLeavePrompt: false,
      disableButtonDuringRequest: false,
      errorFields: null,
      amazonFolderName: uuidV4(),
      isFinishDialogOpen: false,
      isItemSelected: null,
      selectedChargesRows: [],
      selectedCharges: [],
      dueDate: Time.addDays(new Date(), 3) || null,
      isSaving: false
    });
  }

  public closeCollectiveInvoiceCoach = () => {
    this.clearBackEndErrors();
    setTimeout(() => {this.clearState()}, 100);

    this.props.onCloseCollectiveInvoiceCoach.call(this, this.state.property);
  }


  /* Main logic for STEPPER */
  // Logic for stepper, use methods when we click button continue on step page, and we start logic.
  public handleNext = () => {
    const { activeStep } = this.state;
    const steps = this.getSteps();

    if(activeStep === steps.length - 1) { // it is last step
      if(this.state.errorFields?.length > 0){
        this.setState({
          isFinishDialogOpen: true
        });
      } else {
        this.closeCollectiveInvoiceCoach();
      }
    } else {
      switch (activeStep) {
        case 0:
          return this.startStepFirst();
        case 1:
          return this.plusOneStep();
      }
    }
  };

  public handleBack = () => {
    const { activeStep } = this.state;

    if(activeStep === 0) {
      if(typeof this.props.openFirstStep !== "undefined"){
        this.clearFieldsError();
        this.clearBackEndErrors();
        this.clearState();
        return this.props.openFirstStep.call(this);
      }
    } else {
      this.clearFieldsError();
      return this.setState({
        activeStep: activeStep - 1,
        errorFields: null
      });
    }
  }

  public plusOneStep = () => {
    const { activeStep } = this.state;
    this.setState({
      activeStep: activeStep + 1,
    });
  }

  // Here we save all steps name and get count of steps for showing user steps name.
  public getSteps = () => {
    return [this.trans("coach/collectiveinvoice-step/first-title"), this.trans("coach/collectiveinvoice-step/third-title")];
  }

  //All components with content for steps we have here
  public getStepContent = (step) => {
    switch (step) {
      case 0:
        return this.stepContent(step);
      case 1:
        return this.stepContent(step);
      default:
        return this.trans("unknown-step");
    }
  }

  // Content details for diffenrent steps.
  public stepContent = (step) => {
    return (
      <div>
        {step === 0 && this.firstStepDetails()}
        {step === 1 && this.thirdStepDetails()}
      </div>
    )
  }


  // Steppers components content
  public firstStepDetails = () => {
    return (
      <div>
        <div className="info-text">
          {this.trans("coach/collectiveinvoice-step/first-info")}
        </div>
        <div className="charges-section-wrapper">
          <TableComponent
				  	{...this.props}
				  	paginator={{
				  		name: `ContractBalance_${this.props.contract?.id}`,
				  		path: this.props.app.paginator
				  	}}
				  	className="listing-table new-payment-charges-table"
				  	rows={this.getChargesList(this.state.charges, this.state.selectedChargesRows, this.onChargeRowSelection)}
				  />
        </div>
      </div>
    )
  }

  public secondStepDetails = () => {
    return (
      <div>
        <div className="info-text">
          {this.trans("coach/collectiveinvoice-step/second-info")}
        </div>
        <div style={{width: "220px"}}>
          <DatePickerComponent
            {...this.props}
            id="lastDate"
            name="lastDate"
            className="scroll-to-dueDate"
            label={this.trans("due-date")}
            initialDate={this.state.dueDate}
            onChange={date => this.selectDate(date, "dueDate")}
            minDate={new Date()}
            minDatePlusDays={1}
            clearButton={true}
          />
        </div>
      </div>
    )
  }



  public thirdStepDetails = () => {
    return (
      <div>
        {this.state.errorFields ?
          <div>
            <div className="error-list-item">
              {
                this.state.errorFields && this.state.errorFields.map( item => {
                  let transField = this.trans(`coach-error-${item}`)
                  return <div className="success-created-entity-or-error">{this.trans("coach/owner-error/field-label", {field: transField})}</div>
                })
              }
             </div>
             <div className="info-text">
               {this.trans("coach/collectiveinvoice-scenario/company-step/fourth-errorinfo2")}
            </div>
          </div>
          :
          <div className="info-text">
            { this.state.typeOfCollectiveInvoice === "first" ? this.trans("coach/collectiveinvoicefirst-step/third-info") : this.trans("coach/collectiveinvoicefinal-step/third-info")}
          </div>
        }
      </div>
    );
  }

  //Funcionality for steps
  public startStepFirst = () => {
    return this.collectiveStartStepFirst();
  }

  public startStepSecond = () => {
    return this.collectiveStartStepSecond();
  }


  //Methods for step logic
  public collectiveStartStepFirst = () => {
    this.plusOneStep();
  }

  public collectiveStartStepSecond = () => {
    this.plusOneStep();
  }

  public collectiveStartStepThird = () => {
    this.plusOneStep();
  }


  //Methods
  public selectCompany = (company: CompanyInterface, isManuallySelected: boolean): void => {
    this.setState({
      selectedCompany: company,
      hasModifiedData: isManuallySelected ? isManuallySelected : this.state.hasModifiedData
    });
  }

  public selectCompanyName = (name, type) => {
    this.setState({
      defaultCompanyName: type === "owner" ? name : "",
      defaultPoaCompanyName: type === "company" ? name : "",
    })
  }

  public clearCompany = (): void => {
    this.setState({
      hasModifiedData: true,
      selectedCompany: null
    });
  }

  public clearBackEndErrors = () => {
    this.props.dispatch({
      type: Constants.PAGE_CONTACT_COMPANY_CREATE_CLEAR
    })
    this.props.dispatch({
      type: Constants.COACH_ERRORS_CLEAR
    })
  }

  public clearFieldsError = () => {
    this.setState({
      firstNameError: false,
      companyNameError: false
    })
  }

  public changeNameForOwner  = (value) => {
    this.setState({
      searchTextOwner: value
    })
  }

  public onChargeRowSelection = (_event, rows: number[]): void => {
    const row: number = rows[0];
    const charge: ChargeInterface = this.state.charges[row];

    this.selectUnselectCharge(row, charge);
  }

  public selectUnselectCharge = (row: number, selectedCharge: ChargeInterface) => {
    if (selectedCharge.amountRemaining === 0 && selectedCharge.amount !== 0) {
      return;
    }

    if (this.state.selectedChargesRows.includes(row)) {
      const selectedChargesRows = this.state.selectedChargesRows.filter(rowId => rowId !== row);
      const selectedCharges =  this.state.selectedCharges.filter(id => id !== selectedCharge?.id);

      this.setState({
        selectedChargesRows: selectedChargesRows,
        selectedCharges: selectedCharges
      });
    } else {
      this.setState({
        selectedChargesRows: [...this.state.selectedChargesRows, row],
        selectedCharges: [...this.state.selectedCharges, selectedCharge?.id]
      }, () => {
        if (this.state.selectedCharges.length > 0) {
          this.setState({
            hasModifiedData: true
          });
        }
      });
    }
  }

  public selectDate = (date: Date, identifier: string): void => {
    if(!date && (identifier === "lastDate")){
      return;
    }

    this.setState({
      [identifier]: date,
      hasModifiedData: true
    });
  }

  public renderChargeAmountHint = (charge: ChargeInterface) => {
    let status;

    if (charge?.amount === 0) {
			return
		}

    if((0 < charge?.amountRemaining && charge?.amountRemaining < charge?.amount) && charge?.isPayable){
      status = `${this.formatter.formatNumber(charge.amountRemaining, charge.currency)} ${this.trans("status-still-to-pay")} `
    } else if((0 < charge?.amountRemaining && charge?.amountRemaining < charge?.amount) && charge?.isReceivable){
      status = `${this.formatter.formatNumber(charge.amountRemaining, charge.currency)} ${this.trans("status-still-to-receive")}`
    } else if(charge?.amountRemaining === charge?.amount && charge?.isPayable && !charge.isFullyPaid()){
      status = `${this.trans("status-to-pay")}`
    } else if(charge?.amountRemaining === charge?.amount && charge?.isReceivable && !charge.isFullyPaid()){
      status = `${this.trans("status-to-receive")}`
    } else if(charge.isFullyPaid() && charge?.isReceivable){
      status = `${this.trans("status-received")}`
    } else if(charge.isFullyPaid() && charge?.isPayable){
      status = `${this.trans("status-amount/paid")}`
    } else {
      status = ""
    }

    return (
      <span
        style={{
          fontSize: "11px",
          color: "#80808091"
        }}
      >
        {status}
      </span>
    );
  }
  
  public getChargesList = (charges: ChargeInterface[], selectedChargesRows: number[], callback: any): any => {
    return charges
      .filter((charge: ChargeInterface) => !!charge)
      .map((charge: ChargeInterface, index: number) => {
        const isItemSelected = selectedChargesRows.includes(index);
        const labelId = `enhanced-table-checkbox-${index}`;

        return (
          <TableRow
            hover
            key={`charge-${charge.id}`}
            role="checkbox"
            aria-checked={isItemSelected}
            selected={isItemSelected}
          >
            <TableCell
              padding="checkbox"
              onClick={event => {event.preventDefault(); event.stopPropagation(); callback(event, [index])}}
            >
              <Checkbox
                checked={isItemSelected}
                inputProps={{ 'aria-labelledby': labelId }}
                color="primary"
              />
            </TableCell>
            <TableCell style={{width: "24px", paddingLeft: "10px", paddingRight: "5px"}}>
              <div style={{display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px"}}>
                <div
                  style={{color: charge.getIconColor()}}
                  className="icon icon-ic-charge"
                >
                </div>
              </div>
            </TableCell>
            <TableCell style={{width: "100px", maxWidth: "100px"}}>
              <div style={{display: "flex", justifyContent: "flex-start", alignItems: "center"}}>
                <span style={{display: "inline-block", minWidth: "100px"}}>{this.formatter.formatDate(charge.invoiceDate)}</span>
              </div>
            </TableCell>
            <TableCell>
              <div style={{display: "inline-flex", flexDirection: "column"}}>
                <div style={{display: "flex", justifyContent: "flex-start"}}>
                  {charge?.name || "" }
                  {charge.creationTypeDisplayName && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        margin: "2px 0px 0px 5px"
                      }}
                    >
                      <div className="list-label creation-type-label">
                        {charge.creationTypeDisplayName}
                      </div>
                    </div>
                  )}
                </div>
                <span style={{fontSize: "12px", color: "gray"}}>
                  {`${charge && charge.description === "" ? Formatter.checkTranslationType(this.trans(charge?.type?.label, {}, "", charge?.type?.system), charge?.type?.label, charge?.type?.system) + "," +  Formatter.monthFullFormatDate(charge.firstDate) : charge.description} ${!!charge.relatedEntity ? "- " + charge.relatedEntity.displayName : ""}`}
                </span>
              </div>
            </TableCell>
            <TableCell style={{ textAlign: "right", width: "28%" }}>
              {
                <div style={{display: "inline-flex", flexDirection: "column"}}>
                  <span>{charge.chargeClass.id == ChargeClassContainer.pickIdFromLabel("Payable") && charge?.amount > 0 && <span className="minus-style">{'-'}</span>}{this.formatter.formatNumber(charge.amount, charge.currency)}</span>
                  {this.renderChargeAmountHint(charge)}
                </div>
              }
            </TableCell>
          </TableRow>
        );
      });
  }

   public startCreatingCollectiveInvoiceProcess = (preview) => {
    this.saving(() => {
      this.props.dispatch({
        type: Constants.COLLECTIVE_INVOICE_CREATE_START,
        payload: {
          chargeIds: this.state.selectedCharges,
          contractId: this.state.contract?.id,
          dueDate: Time.formatOrNull(this.state.dueDate),
          preview: preview,
          lng: this.state.contract?.person?.languageTypeId === 1 ? "EN" : "NL",
          type: this.state.typeOfCollectiveInvoice
        },
        onSuccess: (url) => {
          if (url) {
            window.open(CasedeskUrl.getAttachment(url), "_blank");
            this.closeCollectiveInvoiceCoach();
          } else {
            this.closeCollectiveInvoiceCoach();
            return this.redirect(`/app/email/send/contract/${this.state.contract?.id}?&firstInvoice=${this.state.typeOfCollectiveInvoice === "first" ? true : false}`);
          }
          this.setState({
            isSaving: false
          })
        },
        onError: (err) => {
          this.setState({
            isSaving: false,
            hasModifiedData: true,
            errorFields: err.fields
          });
        }
      });
    });
   }

  public renderContent = () => {
    const steps = this.getSteps();
    const { activeStep } = this.state;

    return (
      <div className="stepper-wrapper">
        <div className="stepper-container">
        { activeStep !== steps.length &&
          <Stepper activeStep={activeStep}>
            {steps.map((label) => {
              const props = {};
              const labelProps = {};
              return (
                <Step key={label} {...props}>
                  <StepLabel {...labelProps}>{label}</StepLabel>
                </Step>
              );
            })}
          </Stepper>
        }
        <div>
          <div className="step-content-wrapper first-invoice-coach">
            {this.getStepContent(activeStep)}
          </div>
        </div>
      </div>
      { activeStep !== steps.length &&
        <div className={`step-content-button-wrapper button-container`} >
          <Button
            variant="contained"
            color="primary"
            onClick={this.closeCollectiveInvoiceCoach}
            className="cancel-button"
          >
          {this.trans("dialog-button/cancel")}
          </Button>

          <div  style={{display: "flex"}}>
            { activeStep !== 0 &&
              <Button
                color="primary"
                variant="outlined"
                onClick={this.handleBack}
                disabled={this.state.disableButtonDuringRequest}
                style={{marginRight: "15px"}}
              >
                {this.trans("dialog-button/back")}
              </Button>
            }

            { activeStep === steps.length - 1 &&
              <div style={{display: "flex"}}>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => this.startCreatingCollectiveInvoiceProcess(true)}
                  disabled={this.state.disableButtonDuringRequest}
                  style={{marginRight: "15px"}}
                >
                  {this.trans("button-view")}
                </Button>
                <Button
                  color="primary"
                  variant="contained"
                  onClick={() => this.startCreatingCollectiveInvoiceProcess(false)}
                  disabled={this.state.disableButtonDuringRequest}
                >
                  {this.trans("dialog-button/send")}
                </Button>
              </div>
            }

            {
              activeStep !== steps.length - 1 && 
              <Button
                variant="contained"
                color="primary"
                onClick={this.handleNext}
                disabled={this.state.disableButtonDuringRequest}
              >
                {this.trans("coach/propertyowner-button/next")}
              </Button>
            }

          </div>
        </div>
      }
    </div>
    )
  }

  public render() {
    return (
      <div>
        <Dialog
          className={`dialog dialog-window dialog-assistant coach-dialog has-button-padding ${this.props.innerDialogClasses}`}
          open={this.state.openCreateCollectiveInvoiceCoachOpen}
          onClose={this.closeCollectiveInvoiceCoach}
          disableBackdropClick={true}
        >
          <DialogContent>
            {this.renderContent()}
          </DialogContent>
        </Dialog>

        <PromptDialog
          {...this.props}
          openLeavePrompt={this.state.isFinishDialogOpen}
          title={this.trans("title-attention") + "!"}
          content={this.trans("coach-loseinformation/info")}
          positiveButtonLabel={this.trans("dialog-button/continue")}
          negativeButtonLabel={this.trans("dialog-button/cancel")}
          onSave={() => this.setState({ isFinishDialogOpen: false }, this.closeCollectiveInvoiceCoach)}
          onDiscard={() => this.setState({ isFinishDialogOpen: false, considerPaidProcess: false }) }
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}
